import type { LibItemArticle } from '@types';
import domain from '../domain';

const onArticlesSelected = domain.event<{ libItems: LibItemArticle[] }>();

export default onArticlesSelected;
